import {  ModuleWithProviders, NgModule } from '@angular/core';
import { BaseSharedComponent } from './base-shared.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DateTimeService } from './services/date-time.service';
import { SchemaService } from './services/schema.service';
import { TableSortService } from './services/table-sort.service';
import { TranslateModule } from '@ngx-translate/core';
import { ZORRO_MODULES } from './zorro-modules';
import { ALL_COMPONENTS } from './base-shared-all-components';
import { ALL_DIRECTIVES, ALL_PIPES } from './base-shared-pipes-directives';


@NgModule({
  declarations: [
    BaseSharedComponent,
    ...ALL_COMPONENTS,
    ...ALL_PIPES,
    ...ALL_DIRECTIVES,
  ],
  imports: [
    TranslateModule.forChild(),
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ...ZORRO_MODULES,
  ],
  exports: [...ALL_COMPONENTS, ...ALL_PIPES, ...ALL_DIRECTIVES],
  providers: [DateTimeService, TableSortService, SchemaService],
})
export class BaseSharedModule {
  static forRoot(): ModuleWithProviders<BaseSharedModule> {
    return {
    ngModule: BaseSharedModule,
    providers: [ DateTimeService , SchemaService,TableSortService]
    }
    }
}
